import { getRetailerGroupsSpecified } from 'retailer-groups/resources/retailer-groups-api';

export class UserGroupMembershipsController {
  constructor() {
    this.retailerGroups = [];
  }

  canView() {
    return this.user.retailerGroups && this.user.retailerGroups.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/components/group-memberships/user-group-memberships-controller.js